/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_SearchInputs */

const en_platform_plan_search = /** @type {(inputs: Platform_Plan_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search exercises`)
};

const pl_platform_plan_search = /** @type {(inputs: Platform_Plan_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj ćwiczenia`)
};

/**
* | output |
* | --- |
* | "Search exercises" |
*
* @param {Platform_Plan_SearchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_search = /** @type {((inputs?: Platform_Plan_SearchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_SearchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_search(inputs)
	return en_platform_plan_search(inputs)
});